import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fullWidth?: boolean;
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  size = 'lg',
  showIcon = true,
  href = 'https://tryloomy.com/products/loomy-creatine-gummies',
  ...props
}: CTAButtonProps) {
  const baseStyles = 'font-sans font-semibold transition-all duration-300 flex items-center justify-center gap-2 shadow-sm hover:shadow-md min-h-[44px] rounded-full';
  const sizeStyles = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-5 md:px-6 py-3 text-base',
    lg: 'px-8 md:px-10 py-3 md:py-4 text-lg'
  };
  // Muted sage green palette
  const colorStyles = 'bg-[#7C9885] hover:bg-[#6b8572] text-white';
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (props.onClick) {
      props.onClick(e);
    }
  };
  return <motion.button whileHover={{
    scale: 1.01
  }} whileTap={{
    scale: 0.99
  }} className={`
        ${baseStyles}
        ${sizeStyles[size]}
        ${colorStyles}
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-1">
      {children || 'Try Loomy'}
      {showIcon && <ArrowRight className="w-4 h-4 opacity-80" strokeWidth={2} data-id="element-2" />}
    </motion.button>;
}